<template>
  <main class="c-layoutUser js-layoutUser">
    <TheUserNav
      v-if="!isBusiness"
      class="c-layoutUser_headerNav js-fixableHeader"
      :class="{ '-always-top': isFromCoconalaApp }"
      :slug="currentSlug"
      :is-editable="isEditable"
      ref="headerNav"
    >
      <slot name="user-nav" />
    </TheUserNav>
    <UserRelationLinks
      v-if="isLoggedIn && !isLoginUser"
      :user="user"
    />
    <div
      class="c-layoutUser_container"
      :class="{ [`-columns-${columns}`]: true, ['-columns-reverse'] : columnsReverse, '-blogs': isBlog }"
    >
      <div class="c-sub">
        <TheProfileCard
          v-if="showProfile"
          :is-blog="isBlog"
          :user="user"
          :is-side="columns > 1"
          :is-editable="isEditable"
        />
        <slot name="sub" />
      </div>
      <div ref="stickyBorder"></div>
      <TheUserNav
        v-if="showUserNav"
        class="c-layoutUser_subNav js-fixableHeader"
        :slug="currentSlug"
        :is-editable="isEditable"
        ref="subNav"
      />
      <div
        id="c-main"
        class="c-main"
      >
        <slot />
      </div>
    </div>
  </main>
</template>
<script>
import TheProfileCard from '~/components/organisms/TheProfileCard'
import TheUserNav from '~/components/organisms/TheUserNav'
import TheVueport from '~/components/organisms/TheVueport'

import { mapGetters, mapActions, mapState } from 'vuex'

const FOOTER_BOTTOM_SP = '66px'
const FOOTER_BOTTOM_TB = '66px'

const FOOTER_CLASS = 'js-the-footer'
const FOOTER_ADD_CLASS = 'c-theFooter-withoutMarginTop'

export default {
  components: {
    TheProfileCard,
    TheUserNav,
    TheVueport,
    UserRelationLinks: () =>
      import('~/components/organisms/UserRelationLinks' /* webpackChunkName: "UserRelationLinks" */)
  },
  props: {
    columns: {
      type: Number,
      default: 1
    },
    columnsReverse: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    showProfile: {
      type: Boolean,
      default: true
    },
    showUserNav: {
      type: Boolean,
      default: true
    },
    isBlog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSlug: this.getCurrentSlug(this.$route.path),
      lastScrollTop: 0,
      footerBottomBeforeMountedSp: '0',
      footerBottomBeforeMountedTb: '0'
    }
  },
  async mounted() {
    this.$util.on('scroll', window, this.onScroll)

    // 下部固定メニューとフッター内のメニューが重ならないようにpaddingを変更する
    this.footerBottomBeforeMountedSp = this.$store.state.ui.footerBottomSp
    this.updateFooterBottomSp(FOOTER_BOTTOM_SP)
    this.footerBottomBeforeMountedTb = this.$store.state.ui.footerBottomTb
    this.updateFooterBottomTb(FOOTER_BOTTOM_TB)

    if (!this.isBlog) {
      // フッターの固定margin-topを解除（LayoutUser側でpadding-bottomを設定する）
      await this.$nextTick()
      const footer = document.querySelector('.' + FOOTER_CLASS)
      if (footer) footer.classList.add(FOOTER_ADD_CLASS)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)

    this.updateFooterBottomSp(this.footerBottomBeforeMountedSp)
    this.updateFooterBottomTb(this.footerBottomBeforeMountedTb)

    if (!this.isBlog) {
      const footer = document.querySelector('.' + FOOTER_CLASS)
      if (footer) footer.classList.remove(FOOTER_ADD_CLASS)
    }
  },
  methods: {
    ...mapActions('ui', ['updateFooterBottomTb', 'updateFooterBottomSp']),
    getCurrentSlug(path) {
      // ブログのみ新フロントでURLが違うため個別実装
      const firstDir = path.split('/')[1]
      if (firstDir === 'blogs') {
        return 'blogs'
      }

      let thirdDir = path.split('/')[3]
      let slug = thirdDir && thirdDir !== 'edit' ? thirdDir : 'home'
      return slug
    },
    onScroll() {
      if (!this.$refs.subNav) return
      if (this.$util.getStyle(this.$refs.subNav.$el, 'display') === 'none') return
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      let hasEnoughDiff = Math.abs(scrollTop - this.lastScrollTop) > 2
      this.toggleShadow(scrollTop)

      if (hasEnoughDiff) {
        if (scrollTop > this.lastScrollTop) {
          // 下スクロール
          // NOTE: drop shadowの部分がはみ出るため4pxだけ余分に隠す
          this.$refs.subNav.$el.style.top = `-${this.$refs.subNav.$el.offsetHeight + 4}px`
        } else {
          // 上スクロール
          this.$refs.subNav.$el.style.top = `${this.$el.offsetTop - 2}px`
        }
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    },
    toggleShadow(scrollTop) {
      if (!this.$refs.stickyBorder) return
      if (scrollTop > this.$refs.stickyBorder.offsetTop - this.$el.offsetTop) {
        this.$refs.subNav.$el.style.boxShadow = '0 1px 4px 0 rgba(0, 0, 0, 0.2)'
      } else {
        this.$refs.subNav.$el.style.boxShadow = 'none'
      }
    }
  },
  watch: {
    '$route.path'(v) {
      this.$nextTick(() => {
        this.currentSlug = this.getCurrentSlug(v)
      })
    }
  },
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn']),
    ...mapState('pages/users/user', ['isBusiness']),
    user() {
      if (this.isEditable) {
        return this.$store.state.pages.users.my.user
      }
      return this.$store.state.pages.users.user
    },
    isLoginUser() {
      return this.user.id === this.$store.state.auth.user.id
    }
  }
}
</script>
<style lang="scss" scoped>
.c-layoutUser {
  &_container {
    margin: 0 auto;
    padding-bottom: 60px;
    max-width: $breakpoint-xl;
    &.-blogs {
      padding-bottom: 0;
    }
    &.-columns-2 {
      display: flex;
      margin-top: 30px;
      max-width: $content-maxwidth;
      .c-sub {
        min-width: 200px;
        width: 25%;
      }
      .c-main {
        flex: 1;
        margin-left: 20px;
      }
    }
    &.-columns-reverse {
      flex-direction: row-reverse;
      .c-sub {
        margin-left: 20px;
      }
      .c-main {
        margin-left: 0;
      }
    }
    .c-main {
      margin: 0 auto;
      max-width: $content-maxwidth;
    }
  }
  &_headerNav {
    position: sticky;
    top: 100px;
    z-index: z(user-nav);
  }
  &_subNav {
    display: none;
  }
}

@media (max-width: $breakpoint-l) {
  .c-layoutUser {
    &_container {
      &.-columns-2 {
        margin-top: 20px;
      }
    }
  }
}

// c-subHeaderが760pxで消えるためその分空白ができているのでtopを設定
@media (max-width: 760px) {
  .c-layoutUser {
    &_headerNav {
      top: 47px;
    }
  }
}
@media (min-width: $breakpoint-m) {
  .c-layoutUser {
    &_headerNav {
      &.-always-top {
        top: 0;
      }
    }
  }
}

@media (max-width: $breakpoint-m) {
  .c-layoutUser {
    &_container {
      &.-columns-2 {
        display: block;
        margin-top: 0;
        .c-sub {
          width: auto;
        }
        .c-main {
          margin-left: 0;
        }
      }
      &.-columns-reverse {
        .c-sub {
          margin-left: 0;
        }
      }
    }
    &_headerNav {
      display: none;
    }
    &_subNav {
      position: sticky;
      z-index: 10;
      display: block;
      transition: top 0.2s;
    }
  }
}
</style>
